// FILE: /src/Components/Redirectpage/Linkedin.js (FULLY UPDATED)

import React, { useEffect, useState, useMemo } from "react";
import { Spin, message, Result, Button } from 'antd';
import { useNavigate, useLocation } from "react-router-dom";
import * as authServices from '../../services/authConnect';
import { useDispatch } from "react-redux";
import { handleAuthSuccess } from "../../store/Slices/GroupSlice";
import PageSelectionView from '../Public/PageSelectionView';

import {
  finishSocialConnectNavigation,
  returnFromSocialConnectWithoutResult,
} from "../../utils/socialConnectOrigin";

export default function Linkedin() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const [status, setStatus] = useState('processing');
    const [error, setError] = useState('');
    const [selectionData, setSelectionData] = useState(null);

    const params = useMemo(() => new URLSearchParams(location.search), [location.search]);

    useEffect(() => {
        const authStatus = params.get('status');
        const dataParam = params.get('data');

        if (authStatus === 'selection' && dataParam) {
            try {
                const decodedData = JSON.parse(decodeURIComponent(dataParam));
                setSelectionData(decodedData);
                setStatus('selecting');
            } catch (e) {
                setError('Could not read organization data from LinkedIn.');
                setStatus('error');
            }
        } else {
            const code = params.get('code');
            const state = params.get('state');

            if (code && state) {
                authServices.handleCallback('LINKEDIN', code, state)
                    .then(async () => {
  message.success(
    "LinkedIn connected successfully! Refreshing data..."
  );

  const refreshResult =
    await dispatch(
      handleAuthSuccess()
    ).unwrap();

  finishSocialConnectNavigation(
    navigate,
    "/Dashboard/GroupsProfile",
    {
      groups:
        refreshResult.groups ||
        [],
      platform:
        "LINKEDIN",
    }
  );
})
                    .catch(err => {
                        setError(err.message || 'Failed to verify connection with LinkedIn.');
                        setStatus('error');
                    });
            } else {
                setError(params.get('error_description')?.replace(/\+/g, ' ') || 'LinkedIn authentication was cancelled or failed.');
                setStatus('error');
            }
        }
    }, [params, dispatch, navigate]);
    
    const handleFinalize = async (selectedItems) => {
        if (selectedItems.length === 0) {
            message.info("Please select at least one company page.");
            return;
        }
        setStatus('finalizing');
        try {
            await authServices.finalize(
  'LINKEDIN_BUSINESS',
  selectedItems,
  selectionData.stateToken
);

message.success(
  `${selectedItems.length} company page(s) connected successfully!`
);

const refreshResult =
  await dispatch(
    handleAuthSuccess()
  ).unwrap();

finishSocialConnectNavigation(
  navigate,
  "/Dashboard/GroupsProfile",
  {
    groups:
      refreshResult.groups ||
      [],
    platform:
      "LINKEDIN_COMPANY",
  }
);
        } catch (err) {
            setError(err.message || "Failed to save selected company pages.");
            setStatus('error');
        }
    };

    if (status === 'error') {
        return (
            <Result
                status="error"
                title="Connection Failed"
                subTitle={error}
                extra={[
  <Button
    type="primary"
    key="console"
    onClick={() =>
      returnFromSocialConnectWithoutResult(
        navigate
      )
    }
  >
    Go to Brands & Channels
  </Button>,
]}
            />
        );
    }
    
    if (status === 'selecting') {
        return (
            <PageSelectionView
                accounts={selectionData.organizations || []}
                platformName="LinkedIn Company"
                onFinalize={handleFinalize}
                onCancel={() =>
  returnFromSocialConnectWithoutResult(
    navigate
  )
}
accountNameKey="name"
                accountImageKey="logo"
            />
        );
    }

    return (
        <div className="flex flex-col justify-center items-center h-screen">
            <Spin size="large" />
            <p className="mt-4 text-lg text-gray-600">Finalizing connection with LinkedIn...</p>
        </div>
    );
}